<template>
    <ul class="navi-group">
        <li class="navi-item nav-heading rounded">Meine Inserate</li>
        <li class="nav-item" @click="toggleMenu"><router-link :to="{name: 'inserat-uebersicht', params: {page: $store.state.lastOpenedPage}}" class="nav-link" exact>Übersicht meiner Inserate</router-link></li>
        <li class="nav-item" @click="toggleMenu"><router-link :to="{name: 'inserat-create'}" class="nav-link" exact>Neues Inserat erstellen</router-link></li>
        <li class="nav-item" @click="toggleMenu"><router-link :to="{name: 'inserat-statistik'}" class="nav-link" exact>Meine Statistik</router-link></li>
        <li v-if="user && user.user_type == 'privat'" class="nav-item" @click="toggleMenu"><router-link :to="{name: 'packet-upgrade'}" class="nav-link" exact>Inserats-Paket upgraden</router-link></li>
    </ul>
</template>

<script>
    import { ToggleMenuMixin } from '../../../mixins/ToggleMenu';

    export default {
      data(){
        return {
          user: this.$store.state.user
        }
      },
      created() {

        this.$store.watch(user => {
                return this.$store.getters.user;
        }, user => {
            this.user = user;
        });

      },
      mixins: [ToggleMenuMixin]
    }
</script>

<style scoped>

</style>
